<template>
    <div class="rebate">
        <div class="blue-bg white-color" v-if="!token && !result">
            <div class="inner">
                <h2>Double Scoop Rebate Promotion</h2>
                <div v-if="info">{{ info.start | dateTime('MMM d') }} - {{ info.end | dateTime('MMM d, yyyy') }}</div>
                <div v-else>Promotion period is loading...</div>
            </div>
        </div>
        <div class="green-bg black-color" v-if="!token && !result">
            <div class="inner">
                <div>Online rebate to receive up to</div>
                <h2 class="currency" v-if="info">
                    <span class="blue-color">${{ info.maxPrize }}</span>
                </h2>
                <h2 v-else>
                    Prize value is loading...
                </h2>
            </div>
        </div>
        <div class="blue-bg white-color" v-if="result">
            <div class="inner" v-html="result.title"></div>
        </div>
    </div>
</template>

<script>
import { getInfo } from '../service';

export default {
    name: 'Rebate',
    props: ['token'],
    data() {
        return {
            info: null,
            result: null
        };
    },
    mounted() {
        if (!this.token) this.init();

        this.$root.$on('result', res => {
            this.result = res;
            if (!this.result) this.init();
        });
    },
    methods: {
        async init() {
            this.info = await getInfo();
        }
    }
};
</script>

<style lang="scss" scoped>
.rebate {
    display: flex;
    flex: 0 0 auto;

    > div {
        display: flex;
        align-items: center;
        flex: 1;

        &:first-child {
            justify-content: flex-end;
        }

        &:first-child:last-child {
            justify-content: center;
        }

        .inner {
            display: flex;
            flex-direction: column;
            justify-content: center;
            width: 100%;
            height: 8rem;
            padding: 0 $gap;
            text-align: center;
            max-width: $container/2;

            ::v-deep {
                h2,
                h3 {
                    font-size: 2.4rem;
                    font-weight: bold;
                    margin: 0;
                }

                p,
                div,
                h4 {
                    font-size: 2rem;
                    font-weight: normal;
                    margin: 0;
                }
            }
        }
    }

    .currency {
        span + span {
            font-size: 3.6rem;
        }
    }

    @media (max-width: $mobile) and (orientation: portrait) {
        flex-direction: column;
        margin: 0 $gap;

        > div {
            .inner {
                max-width: 100%;
            }

            &:last-child {
                background: transparent;
            }
        }
    }
}
</style>
